import { render } from "./Empty.vue?vue&type=template&id=5f897a5e&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"

import "./Empty.vue?vue&type=style&index=0&id=5f897a5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f897a5e"

export default script